import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

const TermsConditions = () => {
  return (
    <div className="terms-conditions">
      <Helmet>
        <title>Terms & Conditions - Topup Connect</title>
        <meta
          name="description"
          content="Terms and conditions for using Topup Connect services operated by CHOTTU TELECOM"
        />
      </Helmet>

      <h1>Terms & Conditions</h1>
      <p className="effective-date">Last Updated: 01.01.2025</p>

      <section>
        <h2>1. Agreement to Terms</h2>
        <p>
          These Terms & Conditions ("Terms") are a legal agreement between you
          ("User") and <strong>CHOTTU TELECOM</strong>, the legal owner and
          operator of the brand <strong>Topup Connect</strong>. By using our
          website, mobile app, or services including recharge, bill payment, or
          other utilities, you agree to be bound by these Terms.
        </p>
        <p>
          Our office is located at Barasat - 1, Kathuria, Malikapur, Duttapukur,
          Barasat, North 24 Parganas, West Bengal - 700126.
        </p>
      </section>

      <section>
        <h2>2. Eligibility</h2>
        <p>
          Our services are only available to individuals who are at least 18
          years of age and are capable of entering into legally binding
          agreements.
        </p>
      </section>

      <section>
        <h2>3. Description of Services</h2>
        <p>Topup Connect offers the following services:</p>
        <ul>
          <li>Mobile Recharge (Prepaid & Postpaid)</li>
          <li>Utility Bill Payments (Electricity, Gas, Water, etc.)</li>
          <li>DTH Recharge</li>
          <li>Gift Vouchers and Digital Wallet Top-Ups</li>
          <li>Other Digital Services as introduced from time to time</li>
        </ul>
        <p>
          All services are subject to availability. We reserve the right to
          update, remove, or suspend any service without prior notice.
        </p>
      </section>

      <section>
        <h2>4. User Obligations</h2>
        <p>As a user, you agree to:</p>
        <ul>
          <li>Provide accurate, complete, and updated information</li>
          <li>Verify recharge details before confirming any transaction</li>
          <li>Keep your account credentials secure and confidential</li>
          <li>Use the platform only for lawful and personal purposes</li>
        </ul>
      </section>

      <section>
        <h2>5. Payments and Fees</h2>
        <p>
          We accept payments via multiple methods including UPI, Net Banking,
          Cards, and Wallets. All charges are in INR.
        </p>
        <p>
          Topup Connect or CHOTTU TELECOM may apply convenience fees, gateway
          charges, or commission-based deductions which will be shown
          transparently before payment.
        </p>
      </section>

      <section>
        <h2>6. Prohibited Activities</h2>
        <p>Users must not engage in any of the following:</p>
        <ul>
          <li>Illegal, fraudulent, or unauthorized use of the platform</li>
          <li>Use of bots or automation tools to interact with our services</li>
          <li>
            Attempt to hack, reverse engineer, or disrupt system functionality
          </li>
          <li>Impersonation or false identity creation</li>
          <li>Commercial resale of services without written consent</li>
        </ul>
      </section>

      <section>
        <h2>7. Intellectual Property</h2>
        <p>
          All logos, trademarks, brand names, content, and software on Topup
          Connect are the intellectual property of CHOTTU TELECOM or its
          partners. Unauthorized reproduction or usage is strictly prohibited.
        </p>
      </section>

      <section>
        <h2>8. Refunds & Cancellations</h2>
        <p>
          Recharge and bill payments are non-refundable once successfully
          processed. Any refund request due to transaction failure will be
          processed as per our <Link to="/refund-policy">Refund Policy</Link>.
        </p>
      </section>

      <section>
        <h2>9. Privacy Policy</h2>
        <p>
          Your use of our services is also governed by our{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>, which explains how
          we collect, store, and handle your personal data.
        </p>
      </section>

      <section>
        <h2>10. Disclaimers</h2>
        <p>
          While we strive for accuracy and reliability, we do not guarantee
          uninterrupted or error-free services. The use of our platform is at
          your own risk.
        </p>
        <p>
          We are not responsible for issues arising from third-party service
          providers (telecom, electricity boards, banks, etc.).
        </p>
      </section>

      <section>
        <h2>11. Limitation of Liability</h2>
        <p>
          CHOTTU TELECOM and Topup Connect shall not be liable for any direct,
          indirect, incidental, or consequential damages arising from your use
          or inability to use our services.
        </p>
        <p>
          Our liability in any event will be limited to the amount paid by you
          for the disputed transaction.
        </p>
      </section>

      <section>
        <h2>12. Amendments</h2>
        <p>
          We reserve the right to amend these Terms at any time. Updated
          versions will be posted on the website. Continued use after updates
          means you accept the revised Terms.
        </p>
      </section>

      <section>
        <h2>13. Governing Law & Jurisdiction</h2>
        <p>
          These Terms shall be governed in accordance with Indian laws. Any
          legal disputes will be subject to the jurisdiction of the competent
          courts in West Bengal, India.
        </p>
      </section>

      <section>
        <h2>14. Contact Us</h2>
        <p>
          For any queries or support related to these Terms, you may contact us
          at:
        </p>
        <address>
          CHOTTU TELECOM (Topup Connect)
          <br />
          Barasat - 1, Kathuria, Malikapur, Duttapukur
          <br />
          Barasat, North 24 Parganas, West Bengal - 700126
          <br />
          Email: support@topupconnect.in
        </address>
      </section>

      <div className="footer">
        <Link to="/">Back to Home</Link>
        <p>
          By using our services, you confirm that you agree to these Terms &
          Conditions.
        </p>
      </div>
    </div>
  );
};

export default TermsConditions;
